<div
    style="top: 0px; z-index: 10024;"
    class="position-fixed bg-white w-100 h-100">

    <div class="d-flex align-items-center justify-content-center w-100 h-100">
        <div class="w-100 px-3">
            <div class="loader"></div>

            @if (spinnerService.upload; as upload) {

                <div
                    class="upload-progress mx-auto text-center"
                    role="status"
                    aria-live="polite">

                    @if (upload.position) {
                        <p class="text-muted mb-1">
                            Archivo {{ upload.position.index }} de {{ upload.position.total }}
                        </p>
                    }

                    <h3 class="upload-file-name text-break mb-3">
                        <b>{{ upload.fileName }}</b>
                    </h3>

                    <p-progressBar
                        aria-label="Progreso de subida"
                        [value]="upload.percent ?? 0"
                        [showValue]="false"
                        [style]="{ height: '1rem' }" />

                    <p class="mt-2 mb-0 fs-5" aria-hidden="true">
                        <b>{{ upload.percent ?? 0 }}%</b>
                    </p>
                </div>

            } @else {

                <div class="text-center">
                    <h3><b>{{ spinnerService.message }}</b></h3>
                </div>

            }
        </div>
    </div>
</div>
